var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1563 8.6988C18.0891 8.6876 18.0106 8.6876 17.9434 8.6988C16.3968 8.64277 15.1641 7.37638 15.1641 5.80741C15.1641 4.20482 16.4529 2.91602 18.0555 2.91602C19.658 2.91602 20.9468 4.21602 20.9468 5.80741C20.9356 7.37638 19.7029 8.64277 18.1563 8.6988Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0024 15.511C18.5377 15.7688 20.23 15.4998 21.4179 14.7041C22.9981 13.6507 22.9981 11.9248 21.4179 10.8713C20.2188 10.0757 18.5041 9.80668 16.9688 10.0756",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36475 8.6988C7.43199 8.6876 7.51044 8.6876 7.57768 8.6988C9.12424 8.64277 10.357 7.37638 10.357 5.80741C10.357 4.20482 9.06821 2.91602 7.46561 2.91602C5.86302 2.91602 4.57422 4.21602 4.57422 5.80741C4.58543 7.37638 5.81819 8.64277 7.36475 8.6988Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51864 15.511C6.98329 15.7688 5.29104 15.4998 4.1031 14.7041C2.52292 13.6507 2.52292 11.9248 4.1031 10.8713C5.30225 10.0757 7.01691 9.80668 8.55226 10.0756",
    fill: "#828282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7774 15.7261C12.7102 15.7149 12.6317 15.7149 12.5645 15.7261C11.0179 15.6701 9.78516 14.4037 9.78516 12.8348C9.78516 11.2322 11.074 9.94336 12.6765 9.94336C14.2791 9.94336 15.5679 11.2434 15.5679 12.8348C15.5567 14.4037 14.324 15.6813 12.7774 15.7261Z",
    fill: "#828282"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51717 17.9105C7.93699 18.9639 7.93699 20.6898 9.51717 21.7433C11.3103 22.9424 14.2465 22.9424 16.0396 21.7433C17.6198 20.6898 17.6198 18.9639 16.0396 17.9105C14.2577 16.7225 11.3103 16.7225 9.51717 17.9105Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerm);
export default __webpack_public_path__ + "static/media/customerm.23bdd232ba31c3505bee5ff12ba45364.svg";
export { ForwardRef as ReactComponent };